export const styles = (theme) => ({

  categoryNameWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: (props) => (props.depth + 1) * 10,
  },
  categoryName: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  categoryNameParent: {
    extend: 'categoryName',
    fontStyle: 'italic',
    color: theme.palette.greyScale[3],
    paddingLeft: 8,
  },
  categoryRow: {
    width: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 5,
    marginLeft: (props) => props.isRollup ? 10 * (props.depth + 1) : null,
    '&.rollup': {
      background: theme.palette.greyScale[5],
    },
  },
  categoryAmount: {
    flex: 0,
    minWidth: 120,
    paddingLeft: 4,
    paddingRight: 2,
    background: theme.palette.greyScale[6],
    border: `solid 1px ${theme.components.register.fieldBorderColor}`,
    borderRadius: 3,
    marginRight: 6,
    textAlign: 'right',
  },
  rollUpAmount: {
    flex: 0,
    minWidth: 120,
    paddingLeft: 4,
    paddingRight: 2,
    marginRight: (props) => 10 + 20 * (props.depth + 1),
    textAlign: 'right',
  },
  amountInputStyle: {
    paddingTop: 2,
    paddingBottom: 2,
    fontWeight: (props) => props.isRollup ? 500 : null,
  },
  barChartIconHolder: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  barChartIcon: {
    color: theme.components.categoryCard.barChartIconColor,
  },
  deleteIcon: {
    color: theme.palette.greyScale[3],
  },
  categoryReviewCardRoot: {
    maxWidth: 650,
    width: 450,
  },
  categoryReviewTxList: {
    maxHeight: 200,
  },
  hide: {
    visibility: 'hidden',
  },
  iconHolder: {
    minWidth: 82,
  },

});
